App.AuthLoginController = Em.Controller.extend
  session: Em.inject.service()
  env: Em.inject.service('environment')

  # Form fields
  loginValue    : ""
  passwordValue : ""

  loginIsLoading: false

  passwordIsLoading: false
  restoringPassword    : false
  restorePasswordValue : ""
  captchaNotPassed : false
  letterWasSended: false
  recaptchaId: 0
  actions :
    showPasswordRestore : ->
      @set('restoringPassword', true)

    hidePasswordRestore : ->
      @set('restoringPassword', false)
      @set('letterWasSended', false)
      @set('captchaNotPassed', false)
      @set('restorePasswordValue', "")
      false

    sendPasswordRestoreRequest: ->
      email = @get('restorePasswordValue').toLowerCase().trim()
      recaptchaKey = grecaptcha.getResponse(@get('recaptchaId'))
      if !recaptchaKey
        @set('captchaNotPassed', true)
        @set('passwordIsLoading', false)
        @set('letterWasSended', false)
        @set('restoringPassword', false)
        @set('restorePasswordValue', "")
      else
        if email
          @set('passwordIsLoading', true)
          @get('session').restorePassword(email, recaptchaKey)
          .then (data) =>
            @set('captchaNotPassed', false)
            @set('passwordIsLoading', false)
            @set('letterWasSended', true)
            @set('restoringPassword', false)
            @set('restorePasswordValue', "")
          , =>
            @set('passwordIsLoading', false)
      false

    login : ->
      return if @get('loginIsLoading')

      login    = @get('loginValue').toLowerCase().trim()
      password = @get('passwordValue')

      @set('loginIsLoading', true)
      @get('session').login(login, password)
      .then =>
        transition = @get('session').get('lastTransition')

        if transition
          @get('session').set('lastTransition', null)
          transition.retry()
        else
          @transitionToRoute 'index'
      , =>
        alert @get('env').translate('login.cant_login')
      .finally =>
        @set('loginIsLoading', false)
